import type { CSSProperties } from "react";

/**
 * Outer wrapper: the only element that scrolls horizontally.
 * Constant — there is nothing per-instance about it.
 */
export const scrollableOuterStyle: CSSProperties = {
  overflowX: "auto",
};

/**
 * Inner element carries the minWidth so the (grid- or table-based) child
 * keeps its column tracks instead of crushing them. A fresh object per call
 * keeps callers from accidentally sharing/mutating one style instance.
 */
export function scrollableInnerStyle(minWidth: number): CSSProperties {
  return { minWidth: Math.max(0, minWidth) };
}
